import Routes from 'constants/Routes';
import { Outlet } from 'react-router-dom';
import AdSubMenu, { SubMenuTitle } from './components/AdSubMenu';
import { BudgetFiltersProvider } from './Overview/components/useBudgetFilters';
import { InternalDeliveryGroupBudgetSettingsFiltersProvider } from './Budget/components/useInternalDeliveryGroupBudgetSettingsFilters';
import { useAssignmentRequestsGetCounts } from 'api/assignment-requests/assignment-requests';
import useMe from 'contexts/authentication/useMe';
import useAuthenticationState from 'contexts/authentication/useAuthentication';
import {
  AccessAssignmentRequestCountEndpointPolicy,
  includesRoles,
} from 'constants/Roles';
import { CaseTypeEnum } from 'api/model';
import useTranslations from 'contexts/basicData/useTranslations';
import { arraySpreadIf } from 'utils/spreading';
import useHasTestAccessToCarTransportTrucks from 'hooks/useHasTestAccessToCarTransportTrucks';

const AdvertisingPage = () => {
  const { caseTypes } = useTranslations();
  const {
    state: { isAuthenticated },
  } = useAuthenticationState();
  const me = useMe();
  const hasTestAccessToCarTransportTrucks =
    useHasTestAccessToCarTransportTrucks();

  const countsCall = useAssignmentRequestsGetCounts({
    query: {
      refetchInterval: 60000,
      staleTime: 15000,
      enabled:
        isAuthenticated &&
        me !== null &&
        includesRoles(
          AccessAssignmentRequestCountEndpointPolicy.allow,
          me.roles
        ),
    },
  });
  return (
    <BudgetFiltersProvider>
      <InternalDeliveryGroupBudgetSettingsFiltersProvider>
        <AdSubMenu
          items={[
            {
              label: <SubMenuTitle>Uppdrag</SubMenuTitle>,
              path: Routes.internalDeliveryGroup.index,
            },
            {
              label: <SubMenuTitle>Testkörningar</SubMenuTitle>,
              path: Routes.internalDeliveryGroup.testDrives.index,
            },
            ...arraySpreadIf(hasTestAccessToCarTransportTrucks, {
              label: (
                <SubMenuTitle>
                  {caseTypes[CaseTypeEnum.CarTransportTruck]} (Zäkra)
                </SubMenuTitle>
              ),
              path: Routes.internalDeliveryGroup.carTransportTrucks.index,
            }),
            {
              label: (
                <SubMenuTitle>
                  Förfrågningar & Bokningar
                  {(countsCall.data?.numberOfUnhandledRequests ?? 0) > 0 && (
                    <span>{` (${countsCall.data?.numberOfUnhandledRequests ?? 0})`}</span>
                  )}
                </SubMenuTitle>
              ),
              path: Routes.internalDeliveryGroup.requests.index,
            },
            {
              label: <SubMenuTitle>Överblick</SubMenuTitle>,
              path: Routes.internalDeliveryGroup.overview,
            },
            {
              label: <SubMenuTitle>Budget</SubMenuTitle>,
              path: Routes.internalDeliveryGroup.budget,
            },
          ]}
        />
        <Outlet />
      </InternalDeliveryGroupBudgetSettingsFiltersProvider>
    </BudgetFiltersProvider>
  );
};
export default AdvertisingPage;
